import { parseGlobIcon } from '@utils/parse-glob-icon';

export interface Menus {
  path: string;
  name: string;
  key: string;
  target?: string;
  visible?: boolean;
  children?: Menus[];
}

export const menus: Menus[] = [
  {
    path: '/fun',
    name: 'Fun',
    key: 'fun',
  },
  {
    path: '/swap',
    name: 'Swap',
    key: 'swap',
  },
  {
    path: '/pools',
    name: 'Pools',
    key: 'pools',
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    key: 'portfolio',
  },
];
export const getHeaderMenuIcon = parseGlobIcon(
  import.meta.glob('../assets/images/menus/*', {
    eager: true,
    import: 'default',
  }),
);
